import { jsx as _jsx } from "react/jsx-runtime";
const CSS = `
.cg-iconbtn {
  display: inline-flex; align-items: center; justify-content: center;
  background: var(--surface-card); color: var(--text-body);
  border: 1px solid var(--border-default); border-radius: var(--radius-md);
  cursor: pointer; box-shadow: var(--shadow-xs);
  transition: background var(--duration-fast) var(--ease-standard),
              color var(--duration-fast) var(--ease-standard),
              border-color var(--duration-fast) var(--ease-standard),
              transform var(--duration-fast) var(--ease-standard);
}
.cg-iconbtn:hover { background: var(--slate-100); color: var(--text-heading); }
.cg-iconbtn:active { transform: scale(.94); }
.cg-iconbtn:focus-visible { outline: none; box-shadow: var(--shadow-focus); }
.cg-iconbtn:disabled { opacity: .5; cursor: not-allowed; }
.cg-iconbtn svg { width: 1.15em; height: 1.15em; }
.cg-iconbtn--sm { width: var(--control-h-sm); height: var(--control-h-sm); font-size: var(--text-sm); }
.cg-iconbtn--md { width: var(--control-h-md); height: var(--control-h-md); font-size: var(--text-md); }
.cg-iconbtn--lg { width: var(--control-h-lg); height: var(--control-h-lg); font-size: var(--text-lg); }
.cg-iconbtn--round { border-radius: var(--radius-pill); }
.cg-iconbtn--primary { background: var(--brand-primary); color: var(--brand-on-primary); border-color: transparent; }
.cg-iconbtn--primary:hover { background: var(--brand-primary-hover); color: var(--brand-on-primary); }
.cg-iconbtn--ghost { background: transparent; border-color: transparent; box-shadow: none; }
.cg-iconbtn--ghost:hover { background: var(--slate-100); }
.cg-iconbtn--floating { background: rgba(255,255,255,.92); backdrop-filter: blur(4px); box-shadow: var(--shadow-md); }
`;
function injectStyles() {
    if (typeof document !== 'undefined' && !document.getElementById('cg-iconbutton-css')) {
        const s = document.createElement('style');
        s.id = 'cg-iconbutton-css';
        s.textContent = CSS;
        document.head.appendChild(s);
    }
}
export function IconButton({ icon, label, variant = 'default', size = 'md', round = false, className = '', ...rest }) {
    injectStyles();
    const cls = [
        'cg-iconbtn',
        `cg-iconbtn--${size}`,
        variant !== 'default' ? `cg-iconbtn--${variant}` : '',
        round ? 'cg-iconbtn--round' : '',
        className,
    ].filter(Boolean).join(' ');
    return (_jsx("button", { className: cls, "aria-label": label, title: label, ...rest, children: icon }));
}
